<template>
  <b-row>
    <b-col>
      <b-row class="mb-2">
        <b-form-group
          :class="!mostrarRemoverLote ? 'col-3' : 'col-4'"
          style="margin-bottom:0.5rem"
        >
          <busca-input
            v-model="busca"
            @input="buscar"
            @clean="cleanInput($event)"
          />
        </b-form-group>
        <b-col
          v-if="filtrarPorAtivo"
          :class="'col-2'"
        >
          <filtro-rapido
            :filtros="filtroRapido"
            :filtro-inicial="filtroRapido[0]"
            @selecionado="aplicarFiltroRapido($event)"
          />
        </b-col>
        <b-col
          v-else-if="filtrarPorInativo"
          class="col-2"
        >
          <filtro-rapido
            :filtros="filtroRapidoInativo"
            :filtro-inicial="filtroRapidoInativo[0]"
            @selecionado="aplicarFiltroRapido($event)"
          />
        </b-col>
        <slot
          name="botao-filtro-certificado"
        />
        <slot
          name="botao-filtro-documento-licenca"
        />
        <slot name="icones-acao" />
        <b-col :class="!mostrarRemoverLote ? 'col-3 text-right' : (filtrarPorAtivo || filtrarPorInativo) ? 'col-6 text-right' : 'col-8 text-right'">
          <botoes-area
            :permissao-create="permissaoCreate"
            :permissao-delete="permissaoDelete"
            :linhas-selecionadas="linhasSelecionadas"
            :mostrar-deletar="mostrarRemoverLote"
            @novo="novo"
            @remover="removerItens"
          >
            <slot
              slot="botoes-adicionais"
              name="botoes-adicionais"
            />
          </botoes-area>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vue-good-table
            ref="gridVisualizacao"
            mode="remote"
            row-style-class="clickable"
            theme="view"
            :columns="colunasInner"
            :rows="dadosTabela"
            :total-rows="totalLinhas"
            :is-loading.sync="isCarregando"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: true, // disable the select info panel on top
              selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"
            :pagination-options="{
              enabled: true,
              perPage: 20
            }"
            @on-selected-rows-change="onSelecaoAlterada"
            @on-page-change="onAlterarPagina"
            @on-sort-change="onAlterarOrdenacao"
          >
            <!-- @on-cell-click="editarRegistro" -->
            <template
              slot="table-row"
              slot-scope="props"
            >
              <div
                v-for="(coluna, $index) in celulasAdicionais "
                :key="$index"
                style="text-align:center;"
              >
                <span v-if="(props.row.id === coluna.rowId && props.column.label === coluna.label)">{{ coluna.label }}</span>
              </div>

              <coluna-acoes
                v-if="props.column.label === 'Ação'"
                :mostrar-info-modal="mostrarInfoModal"
                :propriedades="props"
                :info="info"
                :permissao-delete="permissaoColunaDelete"
                :permissao-create="permissaoCreate"
                :permissao-update="permissaoUpdate"
                :mostrar-copia="mostarCopia"
                :permissao-imprimir="permissaoImprimir"
                @abrir-info="abrirInfo"
                @fechar-info="fecharInfo"
                @editar="editarItem"
                @copiar="copiarItem"
                @remover="removerItem"
                @imprimir="imprimirItem"
              >
                <!-- Forward named slots from parent consumer into ColunaAcoes -->
                <template v-slot:botao-editar="slotProps">
                  <slot
                    name="botao-editar"
                    :props="slotProps.props"
                  />
                </template>

                <template v-slot:botao-info="slotProps">
                  <slot
                    name="botao-info"
                    :props="slotProps.props"
                  />
                </template>

                <template v-slot:botao-copiar="slotProps">
                  <slot
                    name="botao-copiar"
                    :props="slotProps.props"
                  />
                </template>

                <template v-slot:botao-imprimir="slotProps">
                  <slot
                    name="botao-imprimir"
                    :props="slotProps.props"
                  />
                </template>
                <template v-slot:botao-remover="slotProps">
                  <slot
                    name="botao-remover"
                    :props="slotProps.props"
                  />
                </template>
                <template v-slot:botao-adicional>
                  <slot
                    name="botao-adicional"
                    :props="props"
                  />
                </template>

                <template v-slot:info-adicional>
                  <slot
                    name="info-adicional"
                    :props="props"
                  />
                </template>

                <template v-slot:corpo-info-adicional>
                  <slot
                    name="corpo-info-adicional"
                    :props="props"
                  />
                </template>
              </coluna-acoes>

              <coluna-personalizada
                v-else-if="props.column.type"
                :propriedades="props"
                :permissao-update="permissaoUpdate"
                @editar-item-coluna="editarItemPorColuna($event.editable, $event.row)"
              >
                <slot
                  slot="celula-personalizada"
                  name="celula-personalizada"
                  :props="props"
                />
                <slot
                  slot="etiquetas-personalizadas"
                  name="etiquetas-personalizadas"
                  :props="props"
                />
              </coluna-personalizada>
              <span
                v-else
                :class="props.column.editable && permissaoUpdate ? 'editable-column' : ''"
                @click="editarItemPorColuna(props.column.editable, props.row)"
              >
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
            <!-- no records -->
            <div slot="emptystate">
              <p style="text-align:center; margin:0">
                Nenhum registro foi encontrado.
              </p>
            </div>
            <!-- pagination -->
            <template
              slot="pagination-bottom"
              slot-scope="props"
            >
              <paginacao-base
                :valor="props"
                :quantidade="20"
              />
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
.th-acao {
  width: 8rem !important;
}
.view {
  .vgt-inner-wrap {
    box-shadow: none !important;
  }
}

.main-menu.menu-dark .navigation > li ul li > a {
  padding: 8px 10px 8px 12px;
}

.icone-acao {
  padding: 0.4rem;
}

.editable-column {
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
}

.info-close {
  padding: 0 0.62rem 0.2rem 0.62rem !important;
  margin: -0.1rem -0.5rem -0.8rem auto !important;
}

tr {
  cursor: default !important;
}

table.vgt-table tr.clickable {
  cursor: default;
}

.info-adicional .popover-body {
  max-height: calc(30vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}

.link-editar-cadastro {
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { can } from '@core/libs/acl/utils'

export default {
  name: 'GridVisualizacao',
  components: {
    VueGoodTable,
    'busca-input': () => import('@/shared/components/busca-input/BuscaInput.vue'),
    'filtro-rapido': () => import('@/shared/components/visualizacao-base/shared/components/filtro-rapido/FiltroRapido.vue'),
    'coluna-acoes': () => import('@/shared/components/visualizacao-base/shared/components/coluna-acoes/ColunaAcoes.vue'),
    'coluna-personalizada': () => import('@/shared/components/visualizacao-base/shared/components/coluna-personalizada/ColunaPersonalizada.vue'),
    'botoes-area': () => import('@/shared/components/visualizacao-base/shared/components/botoes-area/BotoesArea.vue'),
    PaginacaoBase: () => import('@/shared/components/paginacao-base/PaginacaoBase.vue'),
    // InformacaoAdicional: () => import('@/shared/components/visualizacao-base/shared/components/informacao-adicional/InformacaoAdicional.vue'),
  },
  props: {
    carregar: {
      type: Function,
      required: true,
    },
    editar: {
      type: Function,
      required: true,
    },
    novo: {
      type: Function,
      required: true,
    },
    remover: {
      type: Function,
      required: true,
    },
    copiar: {
      type: Function,
      default: () => {},
    },
    colunas: {
      type: Array,
      required: true,
    },
    colunasRepetidas: {
      type: Array,
      default: null,
    },
    info: {
      type: Array,
      default: null,
    },
    mostrarInfoModal: {
      type: Boolean,
      default: false,
    },
    removerComSenha: {
      type: Boolean,
      default: false,
    },
    mensagemRemocao: {
      type: String,
      default: '',
    },
    filtros: {
      type: Array,
      default: () => [],
    },
    filtrarPorAtivo: {
      type: Boolean,
      default: false,
    },
    filtrarPorInativo: {
      type: Boolean,
      default: false,
    },
    mostarCopia: {
      type: Boolean,
      default: false,
    },
    exlusaoTexto: {
      type: String,
      default: 'Deseja realmente remover o registro!',
    },
    permissaoDeleteProps: {
      type: Boolean,
      default: true,
    },
    permissaoImprimir: {
      type: Boolean,
      default: false,
    },
    // When false, VisualizacaoBase will NOT render the default ColunaAcoes
    // and will instead render only the provided action slots. Keeps default
    // behavior when true for backwards compatibility.
    usarColunaAcoesPadrao: {
      type: Boolean,
      default: true,
    },
    filtrosAdicionais: {
      type: Array,
      default: () => [],
    },
    mostrarRemoverLote: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCarregando: false,
      colunasInner: [],
      dadosTabela: [],
      totalLinhas: 0,
      busca: '',
      linhasSelecionadas: [],
      colunasAdicionais: [],
      celulasAdicionais: [],
      conteudoImpressao: '',
      servidorParams: {
        filtros: {
        },
        ordenacao: [
          {
            coluna: '',
            tipo: '',
          },
        ],
        page: 1,
        perPage: 20,
      },
      filtroRapido: [{
        label: 'Ativo',
        colunas: ['Ativo'],
        valor: true,
      }, {
        label: 'Inativo',
        colunas: ['Ativo'],
        valor: false,
      }],
      filtroRapidoInativo: [{
        label: 'Ativo',
        colunas: ['Inativo'],
        valor: false,
      }, {
        label: 'Inativo',
        colunas: ['Inativo'],
        valor: true,
      }],
      filtroImutavel: null,
    }
  },
  computed: {
    permissaoCreate: {
      get() {
        return can('create', this.$route.meta.resource)
      },
    },
    permissaoUpdate: {
      get() {
        return can('update', this.$route.meta.resource)
      },
    },
    permissaoDelete: {
      get() {
        if (!this.permissaoDeleteProps) {
          return false
        }
        return can('delete', this.$route.meta.resource)
      },
    },
    permissaoColunaDelete: {
      get() {
        return can('delete', this.$route.meta.resource)
      },
    },
  },
  created() {
    if (this.filtrosAdicionais && this.filtrosAdicionais.length > 0) {
      for (let index = 0; index < this.filtrosAdicionais.length; index += 1) {
        this.filtroRapido.push(this.filtrosAdicionais[index])
      }
    }

    this.colunasInner = [...this.colunas, {
      label: 'Ação', field: 'acao', thClass: 'th-acao', sortable: false,
    }]
    this.filtroImutavel = [...this.filtros]

    if (localStorage.busca && this.$route.name === localStorage.rota) {
      this.busca = localStorage.busca
    } else {
      localStorage.busca = ''
      localStorage.rota = this.$route.name
    }

    if (!this.filtrarPorAtivo) {
      this.servidorParams.filtros = this.filtros
      this.montarGrid()
    }
  },
  methods: {
    buscar() {
      if (!this.isCarregando) {
        this.montarGrid()
        localStorage.busca = this.busca
      }
    },
    cleanInput() {
      this.busca = ''
      this.buscar()
    },
    setValorFiltro() {
      if (this.servidorParams.filtros && this.servidorParams.filtros.length > 0) {
        this.servidorParams.filtros[0].valor = this.busca
      }
    },
    montarGrid() {
      this.isCarregando = true
      this.setValorFiltro()
      this.carregar(this.servidorParams.page, this.servidorParams.perPage,
        {
          filtroBy: this.servidorParams.filtros,
          ordemBy: this.servidorParams.ordenacao,
        })
        .then(payload => {
          this.colunasAdicionais = []
          this.celulasAdicionais = []
          this.servidorParams.page = payload.data.currentPage || 1
          this.totalLinhas = payload.data.rowCount
          this.dadosTabela = payload.data.queryable
          this.isCarregando = false
          this.$emit('carregado', this.dadosTabela)
        })
        .catch(() => {
          this.isCarregando = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível carregar as informações',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        })
    },
    updateParams(newProps) {
      this.servidorParams = { ...this.servidorParams, ...newProps }
    },
    onAlterarPagina(params) {
      this.updateParams({ page: params.currentPage })
      this.montarGrid()
    },
    onAlterarOrdenacao(params) {
      this.updateParams({
        ordenacao: [{
          tipo: params[0].type,
          coluna: params[0].field,
        }],
      })
      this.montarGrid()
    },
    editarItemPorColuna(editable, value) {
      if (editable && this.permissaoUpdate) {
        this.editar(value)
      }
    },
    onSelecaoAlterada(params) {
      this.linhasSelecionadas = params.selectedRows
    },
    editarItem(value) {
      this.editar(value)
    },
    copiarItem(value) {
      this.copiar(value)
    },
    getErroAlerta() {
      return {
        title: 'Remover?',
        text: this.exlusaoTexto,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }
    },
    removerItens() {
      this.$swal(this.getErroAlerta()).then(result => {
        if (result.value) {
          this.remover(this.linhasSelecionadas)
            .then(payload => {
              this.montarGrid()
              this.$swal({
                icon: 'success',
                title: payload ? 'Inativado' : 'Removido!',
                text: payload ? 'Registro inativado com sucesso' : 'Registro removido com sucesso.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Não foi possível remover as informações',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
              throw err
            })
        }
      })
    },
    removerItem(value) {
      this.$swal(this.getErroAlerta())
        .then(result => {
          if (result.value) {
            if (this.removerComSenha) {
              this.$swal({
                title: 'Remover?',
                text: this.mensagemRemocao,
                icon: 'warning',
                input: 'password',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                inputAttributes: {
                  autocomplete: 'new-password',
                },
                customClass: {
                  input: 'mt-1',
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(confirmResult => {
                if (confirmResult.value) {
                  this.removeLinha(value)
                }
              })
            } else {
              this.removeLinha(value)
            }
          }
        })
    },
    removeColunasDuplicadas() {
      const itens = new Set()
      this.colunasAdicionais = this.colunasAdicionais.filter(el => {
        const itemDuplicado = itens.has(el.label)
        itens.add(el.label)
        return !itemDuplicado
      })
    },
    removeLinha(value) {
      this.remover([...value])
        .then(payload => {
          this.montarGrid()
          this.$swal({
            icon: 'success',
            title: payload ? 'Inativado!' : 'Removido!',
            text: payload ? 'Registro inativado com sucesso.' : 'Registro removido com sucesso.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
        .catch(err => {
          this.$handleError(err)
          throw err
        })
    },
    setColunas() {
      const dados = this.dadosTabela
      if (this.colunasRepetidas !== null) {
        for (let i = 0; i < dados.length; i += 1) {
          this.colunasRepetidas.forEach(coluna => {
            for (let j = 0; j < dados[i][coluna.nome].length; j += 1) {
              const propriedade = dados[i][coluna.nome][j]
              this.colunasAdicionais.push(
                {
                  label: `${coluna.label} ${propriedade.nome}`,
                  field: `${propriedade.nome}`,
                  rowId: dados[i].id,
                },
              )
            }
          })
        }
        this.celulasAdicionais = [...this.colunasAdicionais]
        this.removeColunasDuplicadas()
        this.colunasInner = [...this.colunas, ...this.colunasAdicionais, { label: 'Ação', field: 'acao', thClass: 'th-acao' }]
      }
    },
    abrirInfo(rowId) {
      this.$emit('entidades-vinculadas', rowId)

      this.$root.$emit('bv::hide::popover')
      this.$root.$emit('bv::show::popover', `info${rowId}`)
    },
    fecharInfo(rowId) {
      this.$root.$emit('bv::hide::popover', `info${rowId}`)
    },
    aplicarFiltroRapido(filtro) {
      this.servidorParams.filtros = [...this.filtroImutavel]
      if (filtro && filtro !== null) {
        this.servidorParams.filtros.push(filtro)
      }
      this.montarGrid()
    },
    imprimirItem(value) {
      const winPrint = window.open('', '', 'left=0,top=0,bottom=100,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      if (value.imprimir) {
        this.conteudoImpressao = value.imprimir
      }
      winPrint.document.write(`<!DOCTYPE html>
      <html xmlns="http://www.w3.org/1999/xhtml">
        <head>
            <title>Print Test</title>
            <style type="text/css" media="print">
            @page
            {
                size:  auto;
                margin: 0mm;
            }

            html
            {
                background-color: #FFFFFF;
                margin: 0px;
            }

            body
            {
                border: solid 1px white ;
                margin: 10mm 15mm 10mm 15mm;
            }
            </style>
        </head>
        <body>
          <div>
            ${this.conteudoImpressao}
          </div>
        </body>
      </html>`)

      winPrint.document.close()
      winPrint.focus()
      winPrint.print()
      winPrint.close()
    },
  },
}
</script>
